import { render } from "./NewsDetailsView.vue?vue&type=template&id=4c77f8e9&scoped=true"
import script from "./NewsDetailsView.vue?vue&type=script&lang=js"
export * from "./NewsDetailsView.vue?vue&type=script&lang=js"

import "./NewsDetailsView.vue?vue&type=style&index=0&id=4c77f8e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_a183cd1461c0af2cd22f865d8ad5d3fd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c77f8e9"]])

export default __exports__